var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('article',{staticClass:"org-inner"},[_c('ElTabs',[_c('ElTabPane',{attrs:{"label":_vm.$t('账号')}},[_c(_setup.accountCom)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }